import React, { Component } from 'react';
import { FaHome } from "react-icons/fa";

import { AuthContext } from "../authContext";
import { theme } from "../configuration";

import Flex from './shared/Flex';
import HeaderMenu from './shared/headermenu/HeaderMenu';
import HeaderMenuLink from './shared/headermenu/HeaderMenuLink';
import HeaderMenuButton from './shared/headermenu/HeaderMenuButton';
import {isActiveSiteLayoutToolkitUser} from "./shared/utilities/isActiveSiteLayoutToolkitUser";

class Header extends Component {
  static contextType = AuthContext;
  state = {
    isLoggedIn: true,
    isShowAccountMenu: false
  };
  componentDidMount = () => {
    window.document.body.addEventListener('click', () => {this.hideAccountMenu()}, {capture: false});
  };
  componentWillUnmount() {
    window.document.body.removeEventListener('click', this.hideAccountMenu, {capture: false});
    this.setState({isShowAccountMenu: false});
  };
  hideAccountMenu = async () => {
    await this.setState({ isShowAccountMenu: false});
  };
  toggleAccountMenu = async () => { await this.setState({isShowAccountMenu: !this.state.isShowAccountMenu}); };
  render() {

    const siteLayoutToolkit = isActiveSiteLayoutToolkitUser(this.context.userDetails.licences);
    return (
      <HeaderMenu siteLayoutToolkit={siteLayoutToolkit}>
        <Flex>
          <HeaderMenuLink to={`/`}> <FaHome size={theme.sizes.headerIcon} /> </HeaderMenuLink>
          {/*{*/}
          {/*  (this.context.isLoggedIn && this.context.isCityCAD === true)*/}
          {/*  &&*/}
          {/*  <HeaderMenuLink to={`/projects`} title="My Projects">*/}
          {/*    Projects*/}
          {/*  </HeaderMenuLink>*/}
          {/*}*/}
          {
            this.context.isLoggedIn
            &&
            <HeaderMenuLink to={`/account`} title="My Account">
              Account
            </HeaderMenuLink>
          }
          <HeaderMenuLink to={`/help`} title="CityCAD Help"> Help </HeaderMenuLink>
          {
            this.context.isCityCAD === true
            &&
            <HeaderMenuLink to={`/library`} title="CityCAD URB Library">
              {siteLayoutToolkit ? 'Site Objects' : 'Library'}
            </HeaderMenuLink>
          }
        </Flex>
        {
          this.context.isCityCAD
          &&
          (
            this.context.isLoggedIn
            ?
              <Flex>
                <HeaderMenuButton onClick={() => this.context.logout()}>
                  Log out
                </HeaderMenuButton>
              </Flex>
            :
              <Flex>
                <HeaderMenuLink to={`/login`}>
                  Log in
                </HeaderMenuLink>
              </Flex>
          )
        }
      </HeaderMenu>
    );
  }
}

export default Header;
